import http from '@/plugins/axios/axios';

export default class ArquivoFolhaFacilService {

    salvar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-facil/salvar', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-facil/listar', requisicao);
    } 
    
    exportarArquivoFolha(requisicao) {       
        return http.post('/api/documento/arquivo-folha-facil/folha-pag', requisicao, {responseType: 'blob'});
    } 
}